import React, { useContext, useEffect, useState } from "react";
import { AppCtx } from "../../../AppCtx"; // Adjusted path
import { FaPlus, FaMinus } from 'react-icons/fa';
import VerticalQuickMenuComponent, { VerticalMenuButton } from "./VerticalQuickMenuComponent";
import './VerticalQuickMenuWrapper.css'; // Import CSS

// Helper function to create a menu item element
// It now accepts a React element (component instance) directly
export const createQuickMenuButton = (title, element) => (
  <VerticalMenuButton title={title}>
    {element}
  </VerticalMenuButton>
);

// Wrapper component for the vertical quick menu
// Accepts children directly
const VerticalQuickMenuWrapper = ({ children }) => {
  const { showQuickMenu } = useContext(AppCtx);
  const [menuOpen, setMenuOpen] = useState(false);

  // Ensure children are treated as an array and add keys
  const childrenWithKeys = React.Children.map(children, (child, index) => {
    if (React.isValidElement(child)) {
      return React.cloneElement(child, { key: index });
    }
    return child;
  });

  return (
    <>
      {/* Control visibility with showQuickMenu */}
      {(showQuickMenu || menuOpen) && (
        <button
          className="vertical-quick-menu-toggle"
          aria-label={menuOpen ? 'Close quick menu' : 'Open quick menu'}
          onClick={e => {
            e.stopPropagation();
            setMenuOpen((v) => !v);
          }}
        >
          {menuOpen ? <FaMinus /> : <FaPlus />}
        </button>
      )}
      {/* Pass menuOpen state to control visibility, not showQuickMenu */}
      <VerticalQuickMenuComponent visible={menuOpen}>
        {/* Render children directly */}
        {childrenWithKeys}
      </VerticalQuickMenuComponent>
    </>
  );
};

export default VerticalQuickMenuWrapper;
